import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import { Toast } from '@pmu/tornado';

import { useAppDispatch, useAppSelector } from '@store/hooks';
import { actions as toastActions } from '@store/slices/toastSlice';

const TOAST_DURATION_MS = 5000;
const TOAST_CLOSING_DURATION_MS = 500;

const ToastManager = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { visible, children, isClosing } = useAppSelector(state => state.toast);

  useEffect(() => {
    if (visible) {
      dispatch(toastActions.completeHideToast());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  useEffect(() => {
    if (visible && children) {
      const timer = setTimeout(() => {
        dispatch(toastActions.startHideToast());
      }, TOAST_DURATION_MS);

      return () => clearTimeout(timer);
    }

    return () => {};
  }, [visible, children, dispatch]);

  useEffect(() => {
    if (isClosing) {
      const timer = setTimeout(() => {
        dispatch(toastActions.completeHideToast());
      }, TOAST_CLOSING_DURATION_MS);

      return () => clearTimeout(timer);
    }

    return () => {};
  }, [isClosing, dispatch]);

  const handleClose = () => {
    dispatch(toastActions.startHideToast());
  };

  return (
    <Toast toastVisible={visible} onClose={handleClose}>
      {children}
    </Toast>
  );
};

export { ToastManager };
